import { render, staticRenderFns } from "./SalesExecutives.vue?vue&type=template&id=4b251272"
import script from "./SalesExecutives.vue?vue&type=script&lang=js"
export * from "./SalesExecutives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports